export default "__VITE_ASSET__CyJMAFPU__"